export default __webpack_public_path__ + "static/media/GalanoGrotesque-Heavy.41c4eaa0.woff2";